export enum PostStatus {
  Published = 'published',
  Draft = 'draft',
  Deleted = 'deleted',
}
